<template>
  <div class="form-left">
    <div v-for="(formItem,index) in itemList" :key="index">
      <div v-if="edit">
        <FormItem :label="formItem.label" :prop="formItem.prop" v-if="formItem.show">
          <Select v-if="formItem.type==='select'" v-model="formItem.value" @on-change="change(index,$event)" filterable :disabled="formItem.disabled" filterable style="width: 200px;">
            <Option v-for="(item,index) in formItem.selectList" :key="index" :value="item.name" :label="item.name">
              <span>{{item.name}}</span>
              <span style="float:right;color:#ccc;" class="nowrap">{{item.code}}</span>
            </Option>
          </Select>
          <BaseSelect v-else-if="formItem.type=='selector'" :type="formItem.datatype" :value="formItem.value" :autoload="formItem.autoload" :parameter="formItem.parameter" @change="selectorchange(index,$event)" />
          <Input v-else-if="formItem.type==='input'" :disabled="formItem.disabled" @on-change="change(index,$event)" v-model="formItem.value"></Input>
          <Input v-else-if="formItem.type==='textarea'" type="textarea" :rows="4" @on-change="change(index,$event)" v-model="formItem.value" placeholder="请输入"></Input>
          <i-switch v-else-if="formItem.type==='switch'" v-model="formItem.value" @on-change="change(index,$event)">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
          <!-- v-if="peisongfahuodan.danjuzhuangtai=='待发货'"  -->
          <DatePicker v-else-if="formItem.type==='DatePicker'" type="date" :disabled="formItem.disabled" :value="formItem.value" @on-change="change(index,$event)" :clearable="false" :options="formItem.pickerOptions" placeholder="请选择">
          </DatePicker>
          <div v-else-if="formItem.type==='text'">{{formItem.value}}</div>
        </FormItem>
      </div>
      <div v-else>
        <FormItem :label="formItem.label" :prop="formItem.prop" v-if="formItem.show">
          <i-switch v-if="formItem.type==='switch'" disabled v-model="formItem.value" @on-change="change(index,$event)">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
          <span v-else-if="formItem.type=='selector' && formItem.value && formItem.value.name">{{formItem.value.name}}</span> 
          <span v-else>{{formItem.value}}</span>
        </FormItem>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      leftColumns: {
        type: Array,
        default: () => []
      },
      edit: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      itemList() {
        return this.copy(this.leftColumns)
      }
    },
    methods: {
      selectorchange(index, value) {
        this.itemList[index].value = value
        this.change(index)
      },
      change(index) {
        let { key, value } = this.itemList[index]
        this.$emit('change', { [key]: value })
      },
      fahuoriqiChanged(val) {
        this.$emit('fahuoriqiChanged', val)
      }
    }
  }
</script>
<style lang="less">
  .form-left {
    padding: 20px;
    border-right: 1px solid #f1f1f1;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/FormDetailLeft/index.vue?3af170ab